// extracted by mini-css-extract-plugin
module.exports = {"ChatInputLess":"ChatInputLess--N8ji2"};